import styled from "styled-components";

export const UpdateContentContainer = styled.div`
  background-color: ${(props) => props.theme["gray-50"]};
  border-radius: 10px;
  padding: 1rem;

  h1 {
    margin-bottom: 16px;
    border-bottom: 3px solid ${(props) => props.theme["purple-500"]};
    width: fit-content;
  }

  display: grid;
  gap: 24px;
`;

export const ContentSummary = styled.div`
  background-color: ${(props) => props.theme.white};
  padding: 0.5rem;
  border-radius: 10px;
  display: grid;
  gap: 12px;

  div {
    padding: 0.5rem;
    gap: 4px;
    overflow: hidden;
  }

  h3 {
    font-size: 0.8rem;
    color: ${(props) => props.theme["gray-300"]};
  }

  h2 {
    font-size: 1rem;
    color: ${(props) => props.theme["gray-900"]};
  }

  p {
    font-size: 0.875rem;
  }
`;
